import { render } from "./Contact.vue?vue&type=template&id=09b60cbf&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=09b60cbf&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-09b60cbf"

export default script